import { SidebarLayout } from "@spottercomponents/layout/sidebar/sidebar.component";

export const sidebarLayout: SidebarLayout = {
    sections: [
        {
            title: "global.menu_items.headers.explore",
            accessRights: 'public',
            items: [
                {
                    id: "sightings", title: "global.menu_items.sections.sightings", icon: "images", routerLink: '/sightings',
                    items: [
                        { title: "global.menu_items.upload", routerLink: "/sightings/upload" },
                        { title: "global.menu_items.grid", routerLink: "/sightings/grid" },
                        { title: "global.menu_items.map", routerLink: "/sightings/map" }
                    ]
                },
                {
                    id: "absences", title: "global.menu_items.sections.absences", icon: "eye-slash", routerLink: '/absences',
                    items: [
                        { title: "global.menu_items.upload", routerLink: "/absences/upload" },
                        { title: "global.menu_items.grid", routerLink: "/absences/grid" },
                        { title: "global.menu_items.map", routerLink: "/absences/map" }
                    ]
                },
                {
                    id: "data", title: "global.menu_items.sections.data", icon: "chart-line", routerLink: '/data',
                    items: [
                        { title: "global.menu_items.users", routerLink: "/data/users", accessRights: 'adminOnly' },
                        { title: "global.menu_items.sightings", routerLink: "/data/sightings" },
                        { title: "global.menu_items.absences", routerLink: "/data/absences" },
                        { title: "global.menu_items.visitors", routerLink: "/data/visitors", accessRights: 'adminOnly' },
                        { title: "global.menu_items.identify_flowchart", routerLink: "/data/identify-flowchart" },
                        { title: "global.menu_items.export_reports", routerLink: "/data/reports/sightings" }
                    ]
                },
                { id: "leaderboards", title: "global.menu_items.leaderboards", icon: "ranking-star", routerLink: "/leaderboards" },
            ]
        },
        {
            title: "global.menu_items.headers.learn",
            accessRights: 'public',
            items: [
                { id: "map", title: "global.menu_items.identify", icon: "tag", routerLink: "/identify" },
                { id: "learn", title: "global.menu_items.learn", icon: "book-open-reader", routerLink: "/learn" },
                { id: "about", title: "global.menu_items.about", icon: "circle-question", routerLink: "/about" }
            ]
        },
        {
            title: "global.menu_items.headers.profile",
            accessRights: 'authOnly',
            items: [
                { id: "map", title: "global.menu_items.my_dashboard", icon: "chart-simple", routerLink: "/profile/dashboard" },
                { id: "learn", title: "global.menu_items.my_sightings", icon: "camera", routerLink: "/profile/my-sightings" },
                { id: "about", title: "global.menu_items.my_achievements", icon: "trophy", routerLink: "/profile/my-achievements" },
                { id: "about", title: "global.menu_items.my_favourites", icon: "heart", routerLink: "/profile/my-favourites" }
            ]
        },
        {
            title: "global.menu_items.headers.admin",
            accessRights: 'adminOnly',
            items: [
                {
                    id: "admin", title: "global.menu_items.sections.admin", icon: "gear", routerLink: '/admin',
                    items: [
                        { title: "Dashboard", routerLink: "/admin/dashboard", translate: false },
                        { title: "Data Manager", routerLink: "/admin/data", translate: false },
                        { title: "Achievements", routerLink: "/admin/achievements", translate: false },
                        { title: "Server info", routerLink: "/admin/server", translate: false },
                        { title: "Documentation", routerLink: "/admin/documentation", translate: false },
                        { title: "Notifications", routerLink: "/admin/notifications", translate: false },
                    ]
                },
                {
                    id: "admin-tools", title: "global.menu_items.sections.tools", icon: "hammer", routerLink: '/tools',
                    items: [
                        { title: "global.menu_items.bulk_upload", routerLink: "/tools/bulk-upload" },
                        { title: "Bulk Upload v2", routerLink: "/tools/bulk-upload-v2", translate: false },
                        { title: "global.menu_items.bulk_upload_help", routerLink: "/tools/bulk-upload-help" },
                        { title: "global.menu_items.translations", routerLink: "/tools/translations" },
                        { title: "Bulk Delete", routerLink: "/tools/bulk-delete", translate: false },
                    ]
                },
            ]
        }
    ]
};
